import { mapGetters } from 'vuex'
import { some } from 'lodash-es'
import TagListingFiltersModel from '../Models/TagListingFiltersModel'

export default {
  data: () => {
    return {
      tagListingFiltersModel: null
    }
  },
  created () {
    const duplicateTagGroupNamesPerGroup = {}
    this.tagListingFiltersModel = new TagListingFiltersModel(
      this.getUriWithoutOffset,
      this.getFilterQueryStringVar,
      this.getActiveTagFilters,
      this.getIsTopLevelCategory,
      this.getCurrentPageNumber,
      this.config.url.lang,
      this.activeFiltersString,
      duplicateTagGroupNamesPerGroup
    )
  },
  computed: {
    ...mapGetters([
      'getFilterQueryStringVar',
      'getActiveTagFilters',
      'getTagRecordsUsed',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getCurrentPageNumber',
      'getActiveVariationFiltersString',
      'getActiveAttributeFiltersString',
      'config'
    ]),
    activeFiltersString () {
      const variationFiltersString = this.getActiveVariationFiltersString
      const attributeFiltersString = this.getActiveAttributeFiltersString
      if (variationFiltersString !== '' && attributeFiltersString !== '') {
        return variationFiltersString + '&' + attributeFiltersString
      }
      if (variationFiltersString !== '') {
        return variationFiltersString
      }
      if (attributeFiltersString !== '') {
        return attributeFiltersString
      }
      return ''
    }
  },
  methods: {
    filteringLocationManage (group, entry) {
      window.location.assign(this.filteringManage(group, entry))
    },
    filteringManage (group, entry) {
      const isFilterUsed = this.isFilterUsed(group, entry)
      return this.tagListingFiltersModel.createLinkQueryStringFinal(group, entry, isFilterUsed)
    },
    isFilterUsed (group, entry) {
      return some(this.getTagRecordsUsed[group.tagGroupId], { tagId: entry.tagId })
    },
    entryDisplayValue (group, entry, { trim = false, trimLength = 30 } = {}) {
      if (trim) {
        return entry.tagName.length > trimLength ? entry.tagName.substring(0, trimLength) + '...' : entry.tagName
      }
      return entry.tagName
    }
  }
}
